import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { ENDPOINTS } from './ENDPOINTS';

@Injectable({
  providedIn: 'root',
})
export class SearchService {
  private http = inject(HttpClient);

  searchByQuery(type: 'patients' | 'clients' | 'stocks', query = '') {
    return this.http.get<any[]>(
      ENDPOINTS.search.search(type, !query ? '""' : query)
    );
  }
}
